// Version : 0.0.1
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import GoldLoanProposalActionTypes from './gold-loan-proposal.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// GET GOLD LOAN PROPOSAL LIST
	getGoldProposalResponse: null,
	getGoldProposalListArr: [],
	// DELETE GOLD LOAN PROPOSAL
	deleteGoldProposalResponse: null,
	// UPDATE GOLD LOAN PROPOSAL
	updateGoldLoanProposalResponse: null,
	// FETCH GOLD LOAN PROPOSAL DETAILS
	fetchGoldProposalArr: [],
	fetchGoldLoanProposalResponse: null,
	// ADD GOLD LOAN PROPOSAL
	addGoldLoanPropsalResponse: null,
	// APPROVE LOAN PROPOSAL
	approveGoldLoanPropsalResponse: null,
	// REVERT LOAN PROPOSAL
	revertGoldLoanPropsalResponse: null,
	// GET SEARCH GOLD LOAN MEMBER
	getSearchGoldLoanMemberResponse: null,
	getSearchGoldLoanMemberArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD GOLD LOAN PROPOSAL START ***************** */
		case GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_SUCCESS:
			return { ...state, addGoldLoanPropsalResponse: action.payload };

		case GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_FAILURE:
			return { ...state, addGoldLoanPropsalResponse: action.payload };

		case GoldLoanProposalActionTypes.ADD_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addGoldLoanPropsalResponse: null };

		/** ***************** ADD GOLD LOAN PROPOSAL END ***************** */

		/** ***************** UPDATE GOLD LOAN PROPOSAL START ***************** */
		case GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_SUCCESS:
			return { ...state, updateGoldLoanProposalResponse: action.payload };

		case GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_FAILURE:
			return { ...state, updateGoldLoanProposalResponse: action.payload };

		case GoldLoanProposalActionTypes.UPDATE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, updateGoldLoanProposalResponse: null };

		/** ***************** UPDATE GOLD LOAN PROPOSAL END ***************** */

		/** ***************** GET GOLD LOAN PROPOSAL START ***************** */
		case GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				getGoldProposalResponse: action.payload,
				getGoldProposalListArr: docodeHexResponse(action.payload, 'GetGoldLoanProposalKey'),
			};

		case GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_FAILURE:
			return { ...state, getGoldProposalResponse: action.payload };

		case GoldLoanProposalActionTypes.GET_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, getGoldProposalResponse: null };

		/** ***************** GET GOLD LOAN PROPOSAL END ***************** */

		/** ***************** FETCH GOLD LOAN PROPOSAL START ***************** */
		case GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				fetchGoldLoanProposalResponse: action.payload,
				fetchGoldProposalArr: docodeHexResponse(action.payload, 'FetchGoldLoanProposalKey'),
			};

		case GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_FAILURE:
			return { ...state, fetchGoldLoanProposalResponse: action.payload };

		case GoldLoanProposalActionTypes.FETCH_GOLD_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, fetchGoldLoanProposalResponse: null, fetchGoldProposalArr: [] };

		/** ***************** FETCH GOLD LOAN PROPOSAL END ***************** */

		/** ***************** DELETE GOLD LOAN PROPOSAL START ***************** */
		case GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_SUCCESS:
			return { ...state, deleteGoldProposalResponse: action.payload };

		case GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_FAILURE:
			return { ...state, deleteGoldProposalResponse: action.payload };

		case GoldLoanProposalActionTypes.DELETE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, deleteGoldProposalResponse: null };

		/** ***************** DELETE GOLD LOAN PROPOSAL END ***************** */

		/** ***************** GET SEARCH GOLD LOAN MEMBER START ***************** */
		case GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_SUCCESS:
			return {
				...state,
				getSearchGoldLoanMemberResponse: action.payload,
				getSearchGoldLoanMemberArr: docodeHexResponse(
					action.payload,
					'GetSearchGoldLoanMemberKey',
				),
			};

		case GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_FAILURE:
			return { ...state, getSearchGoldLoanMemberResponse: action.payload };

		case GoldLoanProposalActionTypes.GET_SEARCH_GOLD_LOAN_MEMBER_RESPONSE_CHANGED:
			return { ...state, getSearchGoldLoanMemberResponse: null };

		/** ***************** GET SEARCH GOLD LOAN MEMBER END ***************** */

		/** ***************** APPROVE GOLD LOAN PROPOSAL START ***************** */
		case GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				approveGoldLoanPropsalResponse: action.payload,
			};

		case GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_FAILURE:
			return { ...state, approveGoldLoanPropsalResponse: action.payload };

		case GoldLoanProposalActionTypes.APPROVE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, approveGoldLoanPropsalResponse: null };

		/** ***************** APPROVE GOLD LOAN PROPOSAL END ***************** */

		/** ***************** REVERT GOLD LOAN PROPOSAL START ***************** */
		case GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				revertGoldLoanPropsalResponse: action.payload,
			};

		case GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_FAILURE:
			return { ...state, revertGoldLoanPropsalResponse: action.payload };

		case GoldLoanProposalActionTypes.REVERT_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, revertGoldLoanPropsalResponse: null };

		/** ***************** REVERT GOLD LOAN PROPOSAL END ***************** */

		default:
			return state;
	}
};
